import { memo } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { useRoomI18nName } from "./hooks";

export const QuestionRoomI18nName = memo(() => {
	const { name, onSetName } = useRoomI18nName();

	const onChange = (value: string) => {
		onSetName(value);
	};

	return (
		<FeatureIslandCategoryQuestionForMain
			required={true}
			title="部屋名"
			guide="他の部屋との違いがわかりやすい名前にしましょう。英語の場合150文字まで入力ができます。"
			isEdited={name.isEdited}
			hasError={Boolean(name.error)}
			inputChildren={<InputTextField errorMessage={name.error} value={name.value} handleChange={onChange} />}
		/>
	);
});

QuestionRoomI18nName.displayName = "QuestionRoomI18nName";
